// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.NotificationList_notifications__VtpNt {
  width: 100%;
  font-family: "Sora", sans-serif;
  color: #13231D;
  padding-bottom: 40px;
}
.NotificationList_notifications__card__kDyFo {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  padding: 40px;
  min-height: 75vh;
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .NotificationList_notifications__card__kDyFo {
    padding: 24px 20px;
    min-height: auto;
  }
}
.NotificationList_notifications__header__jWl4i {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
}
.NotificationList_notifications__title-group__3kovf {
  text-align: left;
}
.NotificationList_notifications__eyebrow__2ytKH {
  display: block;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #82B194;
  margin-bottom: 8px;
}
.NotificationList_notifications__title__syIKq {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.04em;
  display: flex;
  align-items: center;
  gap: 16px;
}
@media (max-width: 576px) {
  .NotificationList_notifications__title__syIKq {
    font-size: 18px;
  }
}
.NotificationList_notifications__count-badge__wYNVJ {
  font-size: 13px;
  background: #82B194;
  color: #fff;
  padding: 4px 12px;
  border-radius: 999px;
  font-weight: 800;
  box-shadow: 0 4px 10px rgba(130, 177, 148, 0.3);
}
.NotificationList_notifications__toolbar__2m3Mb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}
@media (max-width: 768px) {
  .NotificationList_notifications__toolbar__2m3Mb {
    flex-direction: column;
    align-items: stretch;
  }
}
.NotificationList_notifications__search-wrapper__xM40n {
  flex: 1 1;
  max-width: 450px;
}
.NotificationList_notifications__tabs__bNwzk {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 4px 0 12px;
  scrollbar-width: none;
}
.NotificationList_notifications__tabs__bNwzk::-webkit-scrollbar {
  display: none;
}
.NotificationList_notifications__content__9i-7J {
  flex: 1 1;
}
.NotificationList_notifications__list__6Ojac {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.NotificationList_notifications__status-box__enhu9 {
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
}
.NotificationList_notifications__status-box__enhu9 h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #5F726B;
}
.NotificationList_notifications__status-box__enhu9 p {
  margin: 0;
  font-size: 15px;
  color: #5F726B;
  opacity: 0.7;
}
.NotificationList_notifications__footer__81ZFB {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid rgba(16, 25, 21, 0.08);
}

.NotificationList_notification-item__SGeMQ {
  background: #ffffff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 18px;
  padding: 24px;
  display: flex;
  gap: 20px;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
}
.NotificationList_notification-item__SGeMQ:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  border-color: rgba(130, 177, 148, 0.2);
}
.NotificationList_notification-item--unread__ZGfBX {
  background: #F8F6F2;
  border-left: 4px solid #82B194;
}
.NotificationList_notification-item--unread__ZGfBX .NotificationList_notification-item__title__jus72 {
  color: #82B194;
}
.NotificationList_notification-item__icon-box__SUhcg {
  width: 48px;
  height: 48px;
  background: #fff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 14px;
  display: grid;
  place-items: center;
  color: #5F726B;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
}
.NotificationList_notification-item__icon-box__SUhcg svg {
  font-size: 22px;
}
.NotificationList_notification-item__body__Bq6s0 {
  flex: 1 1;
  min-width: 0;
}
.NotificationList_notification-item__top__2HRUX {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}
.NotificationList_notification-item__title__jus72 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #13231D;
  line-height: 1.2;
}
.NotificationList_notification-item__time__UIoTD {
  font-size: 11px;
  font-weight: 700;
  color: #5F726B;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.6;
  white-space: nowrap;
}
.NotificationList_notification-item__msg__Tl6MX {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #5F726B;
}
.NotificationList_notification-item__footer__B4R7t {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.NotificationList_notification-item__type-tag__fEq7Z {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  padding: 4px 10px;
  background: #F1F5F9;
  border-radius: 8px;
  color: #64748B;
  text-transform: uppercase;
}
.NotificationList_notification-item__unread-dot__wltR7 {
  width: 10px;
  height: 10px;
  background: #D6A640;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(214, 166, 64, 0.1);
}

/* RESPONSIVO */
@media (max-width: 1024px) {
  .NotificationList_notifications__title__syIKq {
    font-size: 32px;
  }
}
@media (max-width: 768px) {
  .NotificationList_notifications__title__syIKq {
    font-size: 26px;
  }
  .NotificationList_notifications__header__jWl4i {
    margin-bottom: 24px;
    gap: 20px;
  }
  .NotificationList_notifications__card__kDyFo {
    padding: 24px 16px;
    border-radius: 20px;
  }
  .NotificationList_notification-item__SGeMQ {
    padding: 16px;
    gap: 12px;
  }
  .NotificationList_notification-item__icon-box__SUhcg {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }
  .NotificationList_notification-item__icon-box__SUhcg svg {
    font-size: 18px;
  }
  .NotificationList_notification-item__title__jus72 {
    font-size: 14px;
  }
  .NotificationList_notification-item__msg__Tl6MX {
    font-size: 13px;
    margin-bottom: 12px;
  }
  .NotificationList_back-btn__oBfoZ {
    font-size: 13px;
    min-height: 40px;
    padding: 0 12px;
  }
}
@media (max-width: 480px) {
  .NotificationList_notifications__title__syIKq {
    font-size: 22px;
    gap: 10px;
  }
  .NotificationList_notifications__count-badge__wYNVJ {
    font-size: 11px;
    padding: 2px 10px;
  }
  .NotificationList_notification-item__top__2HRUX {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 4px;
  }
  .NotificationList_notification-item__time__UIoTD {
    font-size: 10px;
  }
  .NotificationList_notification-item__footer__B4R7t {
    flex-wrap: wrap;
    gap: 10px;
  }
  .NotificationList_pagination__numbers__e1iWE {
    display: none;
  }
  .NotificationList_pagination__nav__RmyYi {
    width: 44px;
    height: 44px;
  }
}
.NotificationList_tab-btn__Bs0w9 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 20px;
  border-radius: 16px;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  white-space: nowrap;
  background: transparent;
  border-color: rgba(130, 177, 148, 0.58);
  color: #32453b;
  border: 1px solid rgba(16, 25, 21, 0.12);
}
.NotificationList_tab-btn__Bs0w9:hover {
  background: rgba(130, 177, 148, 0.12);
  color: #13231D;
  transform: translateY(-1px);
}
.NotificationList_tab-btn--active__IqTTw {
  background: #82B194;
  color: #fff;
  font-weight: 800;
  box-shadow: 0 8px 20px rgba(130, 177, 148, 0.15);
}
.NotificationList_tab-btn--active__IqTTw:hover {
  background: #739F84;
  color: #fff;
}
.NotificationList_tab-btn--active__IqTTw:active {
  background: #678F77;
}

.NotificationList_utility-bar__9hSfn {
  margin-bottom: 24px;
  display: flex;
}

.NotificationList_back-btn__oBfoZ {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 0 16px;
  border-radius: 16px;
  border: 1px solid rgba(16, 25, 21, 0.1);
  background: rgba(248, 244, 240, 0.92);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.03);
  color: #13231D;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s ease;
}
.NotificationList_back-btn__oBfoZ:hover {
  background: #ffffff;
  transform: translateX(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.06);
}

.NotificationList_pagination__pFHEK {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.NotificationList_pagination__nav__RmyYi {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid rgba(16, 25, 21, 0.08);
  background: #fff;
  color: #5F726B;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.NotificationList_pagination__nav__RmyYi:hover:not(:disabled) {
  background: #82B194;
  color: #fff;
  border-color: transparent;
}
.NotificationList_pagination__nav__RmyYi:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.NotificationList_pagination__numbers__e1iWE {
  display: flex;
  gap: 6px;
  background: #fff;
  padding: 4px;
  border-radius: 14px;
  border: 1px solid rgba(16, 25, 21, 0.08);
}
.NotificationList_pagination__num__pnvjc {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 700;
  color: #5F726B;
  cursor: pointer;
  transition: all 0.2s;
}
.NotificationList_pagination__num__pnvjc:hover:not(.NotificationList_pagination__num--active__3El63) {
  background: rgba(130, 177, 148, 0.1);
}
.NotificationList_pagination__num--active__3El63 {
  background: #82B194;
  color: #fff;
}
.NotificationList_pagination__dots__k5IRF {
  color: #5F726B;
  font-weight: 800;
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/NotificationList/NotificationList.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AADA;EACE,WAAA;EACA,+BAAA;EACA,cDMqB;ECLrB,oBAAA;AAIF;AAFE;EACE,mBDHmB;ECInB,wCAAA;EACA,mBD0BY;ECzBZ,2CDyCU;ECxCV,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAIJ;AAFI;EAVF;IAWI,kBAAA;IACA,gBAAA;EAKJ;AACF;AAFE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAIJ;AADE;EACE,gBAAA;AAGJ;AAAE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD3CmB;EC4CnB,kBAAA;AAEJ;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EATF;IAUM,eAAA;EAEN;AACF;AACE;EACE,eAAA;EACA,mBD/DmB;ECgEnB,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+CAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAAJ;AAEI;EANF;IAOM,sBAAA;IACA,oBAAA;EACN;AACF;AAEE;EACE,SAAA;EACA,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AADJ;AAEI;EAAuB,aAAA;AAC3B;AAEE;EACE,SAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAIE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAFJ;AAII;EAAK,SAAA;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDrGhC;ACuGvB;AADI;EAAI,SAAA;EAAW,eAAA;EAAiB,cDtGb;ECsG+B,YAAA;AAOtD;AAJE;EACE,gBAAA;EACA,iBAAA;EACA,4CAAA;AAMJ;;AAFA;EACE,mBAAA;EACA,wCAAA;EACA,mBD3Fc;EC4Fd,aAAA;EACA,aAAA;EACA,SAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AAKF;AAHE;EACE,2BAAA;EACA,0CAAA;EACA,sCAAA;AAKJ;AAFE;EACE,mBDvImB;ECwInB,8BAAA;AAIJ;AAFI;EACI,cDpJe;ACwJvB;AAAE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cDlJmB;ECmJnB,cAAA;EACA,0CAAA;AAEJ;AAAI;EAAM,eAAA;AAGV;AAAE;EACE,SAAA;EACA,YAAA;AAEJ;AACE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AAEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cD1KmB;EC2KnB,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,cDhLmB;ECiLnB,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cD3LmB;ACyLvB;AAKE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,mBD7NmB;EC8NnB,kBAAA;EACA,6CAAA;AALJ;;AASA,eAAA;AAEA;EAEI;IAAW,eAAA;EAPb;AACF;AAUA;EAEI;IAAW,eAAA;EARb;EASE;IAAY,mBAAA;IAAqB,SAAA;EALnC;EAME;IAAU,kBAAA;IAAoB,mBAAA;EAFhC;EAKA;IACE,aAAA;IACA,SAAA;EAHF;EAKE;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EAHN;EAIM;IAAM,eAAA;EADZ;EAIE;IAAW,eAAA;EADb;EAEE;IAAS,eAAA;IAAiB,mBAAA;EAE5B;EACA;IAAY,eAAA;IAAiB,gBAAA;IAAkB,eAAA;EAI/C;AACF;AAFA;EAEQ;IAAW,eAAA;IAAiB,SAAA;EAKlC;EAJM;IAAiB,eAAA;IAAiB,iBAAA;EAQxC;EAJM;IACI,8BAAA;IACA,uBAAA;IACA,QAAA;EAMV;EAJM;IAAU,eAAA;EAOhB;EANM;IAAY,eAAA;IAAiB,SAAA;EAUnC;EANM;IAAa,aAAA;EASnB;EARM;IAAS,WAAA;IAAa,YAAA;EAY5B;AACF;AARA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oFD1SU;EC2SV,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kDAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,cAAA;EACA,wCAAA;AAUF;AARE;EACE,qCAAA;EACA,cDrSmB;ECsSnB,2BAAA;AAUJ;AAPE;EACE,mBDvTmB;ECwTnB,WAAA;EACA,gBAAA;EACA,gDAAA;AASJ;AAPI;EACE,mBD5TiB;EC6TjB,WAAA;AASN;AANI;EACE,mBDhUiB;ACwUvB;;AAHA;EACE,mBAAA;EACA,aAAA;AAMF;;AAHA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,2CAAA;EACA,cDzUqB;EC0UrB,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAMF;AAJE;EACE,mBAAA;EACA,2BAAA;EACA,2CAAA;AAMJ;;AAFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAKF;AAHE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;EACA,cDjWmB;ECkWnB,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAKJ;AAHI;EACI,mBDtXe;ECuXf,WAAA;EACA,yBAAA;AAKR;AAFI;EAAa,YAAA;EAAc,mBAAA;AAM/B;AAHE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;AAKJ;AAFE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDjYmB;ECkYnB,eAAA;EACA,oBAAA;AAIJ;AAFI;EACI,oCAAA;AAIR;AADI;EACI,mBDxZe;ECyZf,WAAA;AAGR;AACE;EACE,cDhZmB;ECiZnB,gBAAA;EACA,cAAA;AACJ","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-primary-hover: $color-primary-hover;\n$bw-primary-active: $color-primary-active;\n$bw-text: $text-main;\n$bw-muted: $text-muted;\n$bw-border: $color-border;\n$bw-surface: $color-surface;\n$bw-surface-soft: $color-surface-soft;\n$bw-gold: $color-gold;\n$bw-radius-xl: $radius-xl;\n$bw-radius-lg: $radius-lg;\n$bw-shadow: $shadow-card;\n\n.notifications {\n  width: 100%;\n  font-family: \"Sora\", sans-serif;\n  color: $bw-text;\n  padding-bottom: 40px;\n\n  &__card {\n    background: $bw-surface;\n    border: 1px solid $bw-border;\n    border-radius: $bw-radius-xl;\n    box-shadow: $bw-shadow;\n    padding: 40px;\n    min-height: 75vh;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 768px) {\n      padding: 24px 20px;\n      min-height: auto;\n    }\n  }\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-bottom: 24px;\n  }\n\n  &__title-group {\n    text-align: left;\n  }\n\n  &__eyebrow {\n    display: block;\n    font-size: 11px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.14em;\n    color: $bw-primary;\n    margin-bottom: 8px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 28px;\n    font-weight: 800;\n    letter-spacing: -0.04em;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    @media (max-width: 576px) {\n        font-size: 18px;\n    }\n  }\n\n  &__count-badge {\n    font-size: 13px;\n    background: $bw-primary;\n    color: #fff;\n    padding: 4px 12px;\n    border-radius: 999px;\n    font-weight: 800;\n    box-shadow: 0 4px 10px rgba(130, 177, 148, 0.3);\n  }\n\n  &__toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n        align-items: stretch;\n    }\n  }\n\n  &__search-wrapper {\n    flex: 1;\n    max-width: 450px;\n  }\n\n  &__tabs {\n    display: flex;\n    gap: 12px;\n    overflow-x: auto;\n    padding: 4px 0 12px;\n    scrollbar-width: none;\n    &::-webkit-scrollbar { display: none; }\n  }\n\n  &__content {\n    flex: 1;\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__status-box {\n    padding: 80px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 16px;\n\n    h3 { margin: 0; font-size: 20px; font-weight: 800; color: $bw-muted; }\n    p { margin: 0; font-size: 15px; color: $bw-muted; opacity: 0.7; }\n  }\n\n  &__footer {\n    margin-top: 40px;\n    padding-top: 24px;\n    border-top: 1px solid $bw-border;\n  }\n}\n\n.notification-item {\n  background: #ffffff;\n  border: 1px solid $bw-border;\n  border-radius: $bw-radius-lg;\n  padding: 24px;\n  display: flex;\n  gap: 20px;\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  position: relative;\n  overflow: hidden;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);\n    border-color: rgba($bw-primary, 0.2);\n  }\n\n  &--unread {\n    background: $bw-surface-soft;\n    border-left: 4px solid $bw-primary;\n    \n    .notification-item__title {\n        color: $bw-primary;\n    }\n  }\n\n  &__icon-box {\n    width: 48px;\n    height: 48px;\n    background: #fff;\n    border: 1px solid $bw-border;\n    border-radius: 14px;\n    display: grid;\n    place-items: center;\n    color: $bw-muted;\n    flex-shrink: 0;\n    box-shadow: 0 4px 10px rgba(0,0,0,0.02);\n\n    svg { font-size: 22px; }\n  }\n\n  &__body {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 6px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 800;\n    color: $bw-text;\n    line-height: 1.2;\n  }\n\n  &__time {\n    font-size: 11px;\n    font-weight: 700;\n    color: $bw-muted;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    opacity: 0.6;\n    white-space: nowrap;\n  }\n\n  &__msg {\n    margin: 0 0 16px;\n    font-size: 14px;\n    line-height: 1.6;\n    color: $bw-muted;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__type-tag {\n    font-size: 10px;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n    padding: 4px 10px;\n    background: #F1F5F9;\n    border-radius: 8px;\n    color: #64748B;\n    text-transform: uppercase;\n  }\n\n  &__unread-dot {\n    width: 10px;\n    height: 10px;\n    background: $bw-gold;\n    border-radius: 50%;\n    box-shadow: 0 0 0 4px rgba($bw-gold, 0.1);\n  }\n}\n\n/* RESPONSIVO */\n\n@media (max-width: 1024px) {\n  .notifications {\n    &__title { font-size: 32px; }\n  }\n}\n\n@media (max-width: 768px) {\n  .notifications {\n    &__title { font-size: 26px; }\n    &__header { margin-bottom: 24px; gap: 20px; }\n    &__card { padding: 24px 16px; border-radius: 20px; }\n  }\n\n  .notification-item {\n    padding: 16px;\n    gap: 12px;\n\n    &__icon-box { \n        width: 40px; \n        height: 40px; \n        border-radius: 12px;\n        svg { font-size: 18px; }\n    }\n\n    &__title { font-size: 14px; }\n    &__msg { font-size: 13px; margin-bottom: 12px; }\n  }\n\n  .back-btn { font-size: 13px; min-height: 40px; padding: 0 12px; }\n}\n\n@media (max-width: 480px) {\n    .notifications {\n        &__title { font-size: 22px; gap: 10px; }\n        &__count-badge { font-size: 11px; padding: 2px 10px; }\n    }\n\n    .notification-item {\n        &__top { \n            flex-direction: column-reverse; \n            align-items: flex-start;\n            gap: 4px;\n        }\n        &__time { font-size: 10px; }\n        &__footer { flex-wrap: wrap; gap: 10px; }\n    }\n\n    .pagination {\n        &__numbers { display: none; }\n        &__nav { width: 44px; height: 44px; }\n    }\n}\n\n\n.tab-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 0 20px;\n  border-radius: 16px; \n  font-family: $font-main;\n  font-size: 14px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  white-space: nowrap;\n  background: transparent;\n  border-color: rgba(130, 177, 148, .58);\n  color: #32453b;\n  border: 1px solid rgba(16, 25, 21, .12);\n\n  &:hover { \n    background: rgba(130, 177, 148, .12);\n    color: $bw-text; \n    transform: translateY(-1px);\n  }\n\n  &--active {\n    background: $bw-primary;\n    color: #fff;\n    font-weight: 800;\n    box-shadow: 0 8px 20px rgba($bw-primary, 0.15);\n\n    &:hover {\n      background: $bw-primary-hover;\n      color: #fff;\n    }\n\n    &:active {\n      background: $bw-primary-active;\n    }\n  }\n}\n\n.utility-bar {\n  margin-bottom: 24px;\n  display: flex;\n}\n\n.back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 44px;\n  padding: 0 16px;\n  border-radius: 16px; // Radio oficial (LOCK)\n  border: 1px solid rgba(16, 25, 21, 0.1);\n  background: rgba(248, 244, 240, 0.92);\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.03);\n  color: $bw-text;\n  font-size: 14px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover { \n    background: #ffffff; \n    transform: translateX(-4px); \n    box-shadow: 0 12px 24px rgba(0,0,0,0.06);\n  }\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n\n  &__nav {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    border: 1px solid $bw-border;\n    background: #fff;\n    color: $bw-muted;\n    display: grid;\n    place-items: center;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &:hover:not(:disabled) {\n        background: $bw-primary;\n        color: #fff;\n        border-color: transparent;\n    }\n\n    &:disabled { opacity: 0.3; cursor: not-allowed; }\n  }\n\n  &__numbers {\n    display: flex;\n    gap: 6px;\n    background: #fff;\n    padding: 4px;\n    border-radius: 14px;\n    border: 1px solid $bw-border;\n  }\n\n  &__num {\n    width: 32px;\n    height: 32px;\n    border-radius: 10px;\n    border: none;\n    background: transparent;\n    font-size: 13px;\n    font-weight: 700;\n    color: $bw-muted;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &:hover:not(.pagination__num--active) {\n        background: rgba($bw-primary, 0.1);\n    }\n\n    &--active {\n        background: $bw-primary;\n        color: #fff;\n    }\n  }\n\n  &__dots {\n    color: $bw-muted;\n    font-weight: 800;\n    padding: 0 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notifications": `NotificationList_notifications__VtpNt`,
	"notifications__card": `NotificationList_notifications__card__kDyFo`,
	"notifications__header": `NotificationList_notifications__header__jWl4i`,
	"notifications__title-group": `NotificationList_notifications__title-group__3kovf`,
	"notifications__eyebrow": `NotificationList_notifications__eyebrow__2ytKH`,
	"notifications__title": `NotificationList_notifications__title__syIKq`,
	"notifications__count-badge": `NotificationList_notifications__count-badge__wYNVJ`,
	"notifications__toolbar": `NotificationList_notifications__toolbar__2m3Mb`,
	"notifications__search-wrapper": `NotificationList_notifications__search-wrapper__xM40n`,
	"notifications__tabs": `NotificationList_notifications__tabs__bNwzk`,
	"notifications__content": `NotificationList_notifications__content__9i-7J`,
	"notifications__list": `NotificationList_notifications__list__6Ojac`,
	"notifications__status-box": `NotificationList_notifications__status-box__enhu9`,
	"notifications__footer": `NotificationList_notifications__footer__81ZFB`,
	"notification-item": `NotificationList_notification-item__SGeMQ`,
	"notification-item--unread": `NotificationList_notification-item--unread__ZGfBX`,
	"notification-item__title": `NotificationList_notification-item__title__jus72`,
	"notification-item__icon-box": `NotificationList_notification-item__icon-box__SUhcg`,
	"notification-item__body": `NotificationList_notification-item__body__Bq6s0`,
	"notification-item__top": `NotificationList_notification-item__top__2HRUX`,
	"notification-item__time": `NotificationList_notification-item__time__UIoTD`,
	"notification-item__msg": `NotificationList_notification-item__msg__Tl6MX`,
	"notification-item__footer": `NotificationList_notification-item__footer__B4R7t`,
	"notification-item__type-tag": `NotificationList_notification-item__type-tag__fEq7Z`,
	"notification-item__unread-dot": `NotificationList_notification-item__unread-dot__wltR7`,
	"back-btn": `NotificationList_back-btn__oBfoZ`,
	"pagination__numbers": `NotificationList_pagination__numbers__e1iWE`,
	"pagination__nav": `NotificationList_pagination__nav__RmyYi`,
	"tab-btn": `NotificationList_tab-btn__Bs0w9`,
	"tab-btn--active": `NotificationList_tab-btn--active__IqTTw`,
	"utility-bar": `NotificationList_utility-bar__9hSfn`,
	"pagination": `NotificationList_pagination__pFHEK`,
	"pagination__num": `NotificationList_pagination__num__pnvjc`,
	"pagination__num--active": `NotificationList_pagination__num--active__3El63`,
	"pagination__dots": `NotificationList_pagination__dots__k5IRF`
};
export default ___CSS_LOADER_EXPORT___;
